import { EventTypes } from 'redux-segment';
import { getUserContext } from '@ordermentum/ui-shared/utilities/user';
import { AsyncThunkDispatch } from '@ordermentum/ui-definitions';

import * as C from '../constants';

export type SendPageAnalytics = ({
  page,
}: {
  page: string;
}) => AsyncThunkDispatch;

export const sendPageAnalytics =
  ({ page }: { page: string }) =>
  async dispatch =>
    dispatch({
      type: C.SEND_PAGE_ANALYTICS,
      meta: {
        analytics: {
          eventType: EventTypes.page,
          eventPayload: {
            name: page,
            properties: {
              persona: 'Lead',
              ...getUserContext(),
            },
          },
        },
      },
    });

export type TrackEvent = ({
  type,
  event,
  properties,
}: {
  type: string;
  event: string;
  properties?: object;
}) => AsyncThunkDispatch;

export const trackEvent =
  ({ type, event, properties = {} }) =>
  async dispatch =>
    dispatch({
      type: C.TRACK_EVENT,
      meta: {
        analytics: {
          eventType: EventTypes.track,
          eventPayload: {
            event,
            properties: {
              ...getUserContext(),
              type,
              ...properties,
            },
          },
        },
      },
    });
